import { Slide } from '@features/powerpoint';
import { howWeDoItSlide as baseSlide } from '@features/lci-report/slides/appendix/how-we-do-it-slide';

export const howWeDoItSlide = (): Slide => {
  return baseSlide({
    toplineText:
      '<lci>Lift Conversion Index (LCI®)</lci>, powered by industry-leading, robust sales data, provides the most accurate and holistic view into how your media drives consumer sales!',
    conversionText: 'Audience makes an item level purchase',
    attributionText:
      'LCI measures incremental return on ad spend in sales and lift!',
  });
};
